import { render, staticRenderFns } from "./anli.vue?vue&type=template&id=856f12ee&scoped=true&"
import script from "./anli.vue?vue&type=script&lang=js&"
export * from "./anli.vue?vue&type=script&lang=js&"
import style0 from "./anli.vue?vue&type=style&index=0&id=856f12ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856f12ee",
  null
  
)

export default component.exports